const SvgIconBucketlistHeartOff = (props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M29.6 6c-1.6-1.7-3.8-2.6-6.1-2.6-3.4 0-5.5 1.9-6.7 3.5-.3.4-.6.8-.8 1.2-.2-.4-.5-.8-.8-1.2-1.2-1.6-3.3-3.5-6.7-3.5-2.4 0-4.5.9-6.1 2.6C.9 7.6.1 9.8.1 12.1c0 2.5 1 4.9 3.3 7.4 2 2.3 4.8 4.6 8.2 7.3 1.2 1 2.5 2 3.9 3.2.2.1.4.2.6.2.2 0 .4-.1.6-.2 1.4-1.1 2.6-2.2 3.9-3.2 3.3-2.7 6.2-5 8.2-7.3 2.2-2.5 3.3-4.9 3.3-7.4-.2-2.3-1-4.5-2.5-6.1zM19.3 25.5L16 28.2c-1.2-1-2.2-1.9-3.3-2.7-6.5-5.3-10.8-8.7-10.8-13.3 0-1.9.7-3.7 1.9-5 1.2-1.3 2.9-2 4.7-2 2.6 0 4.2 1.5 5.2 2.8.8 1.1 1.3 2.3 1.4 2.7.1.4.5.6.9.6s.8-.2.9-.6c.1-.4.6-1.6 1.4-2.7.9-1.3 2.6-2.8 5.2-2.8 1.8 0 3.5.7 4.7 2 1.2 1.3 1.9 3.1 1.9 5 0 4.6-4.3 8-10.8 13.3z"
    />
  </svg>
)

export default SvgIconBucketlistHeartOff
